// extracted by mini-css-extract-plugin
module.exports =  {"stickyTableCell":"SmartTableCell-module__stickyTableCell--azrAE","stickyTableCellBorder":"SmartTableCell-module__stickyTableCellBorder--jmGPb"};